<template>
    <v-content>
        <v-row class="pb-0 pb-sm-10">
            <v-col class="display-1">
                {{ action === "update" ? "Редактирование аккаунта рассылок" : "Создание аккаунта рассылок" }}
            </v-col>
            <v-col>
                <div class="float-right">
                    <v-btn color="info" depressed @click="back()">
                        Назад
                    </v-btn>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="5" class="pa-4">
                <div class="w100">
                    <p class="text-field-header">Название:</p>
                    <v-text-field
                        outlined
                        label="Название"
                        v-model="mailing_account.name"
                    ></v-text-field>
                </div>
            </v-col>
            <v-col cols="5" class="pa-4">
                <div class="w100">
                    <p class="text-field-header">API ключ:</p>
                    <v-text-field
                        outlined
                        label="API ключ"
                        clearable
                        v-model="mailing_account.api_key"
                    ></v-text-field>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="5" class="pa-4">
                <div class="w100">
                    <p class="text-field-header">Тип уведомления:</p>
                    <v-select
                        v-model="mailing_account.type_of_notification"
                        :items="types_of_notification"
                        item-text="name"
                        item-value="value"
                        label="Тип уведомления"
                        outlined
                        hide-details
                        clearable
                        dense
                        :disabled="mailing_account.id"
                      />
                </div>
            </v-col>
            <v-col cols="5" class="pa-4">
                <div class="w100">
                    <p class="text-field-header">Тип аккаунта:</p>
                    <v-select
                        v-model="mailing_account.type_of_account"
                        :items="types_of_account.filter(option => option.type===mailing_account.type_of_notification)"
                        item-text="name"
                        item-value="value"
                        label="Тип аккаунта"
                        outlined
                        hide-details
                        clearable
                        dense
                        :disabled="mailing_account.id"
                      />
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="5" class="pa-4">
                <div class="w100">
                    <p class="text-field-header">Валюта:</p>
                    <v-text-field
                        outlined
                        label="Валюта"
                        v-model="mailing_account.currency"
                    ></v-text-field>
                </div>
            </v-col>
        </v-row>
        <v-col>
            <div class="float-right">
                <v-btn color="primary" depressed @click="saveAccount()">
                    <v-icon small>mdi-plus</v-icon>
                    Сохранить
                </v-btn>
            </div>
        </v-col>
        <OverlayLoader :show="isLoading"></OverlayLoader>
    </v-content>
</template>

<script>
import OverlayLoader from "@/app/shared/components/app-loader/Loader";

export default {
    name: "AdminUpdateSettings",
    components: {
        OverlayLoader,
    },
    data() {
        return {
            types_of_account: [
                {
                    name: 'Unicore',
                    value: 'unicore',
                    type: 'sms',
                },
                {
                    name: 'P1SMS',
                    value: 'p1sms',
                    type: 'sms',
                },
                {
                    name: 'Mobizon',
                    value: 'mobizon',
                    type: 'sms',
                },
                {
                    name: 'Zvonobot',
                    value: 'zvonobot',
                    type: 'call',
                },
            ],
            types_of_notification: [
                {
                    name: 'СМС',
                    value: 'sms',
                },
                {
                    name: 'Звонок',
                    value: 'call',
                },
            ]
        };
    },
    created() {
        if (this.action == "update") {
            this.$store.dispatch("GET_MAILING_ACCOUNT_BY_ID", this.accountId);
        }
    },
    computed: {
        accountId() {
            return this.$route.params.id;
        },
        action() {
            return this.$route.name == "UpdateAccount" && this.accountId ? "update" : "create";
        },
        mailing_account() {
            return this.$store.getters.CURRENT_MAILING_ACCOUNT;
        },
        isLoading() {
            return this.$store.getters.CURRENT_MAILING_ACCOUNT_LOADING;
        },
    },
    methods: {
        saveAccount() {
            const action_path = this.action === "create" ? "CREATE_MAILING_ACCOUNT": "UPDATE_MAILING_ACCOUNT";
            this.$store
                .dispatch(action_path, this.mailing_account)
                .then(() => {
                    this.$toast.success("Аккаунт сохранён");
                    this.back();
                })
                .catch(() => {
                    this.$toaster.error("Неизвестная ошибка!");
                });
        },
        back() {
            this.$router.push({ path: "/account-mailers" });
        },
    },
};
</script>

<style></style>
